<div class="w-full text-left">
  <app-manual-hero
    eyebrow="ติดต่อเรา"
    title="แจ้งปัญหา / ติดต่อบริษัท"
    subtitle="พบปัญหาการใช้งาน ติดต่อเราได้ตามช่องทางด้านล่าง"
    icon="/icons/help_slate_dark.svg"
  ></app-manual-hero>

  <div class="relative z-10 -mt-7 space-y-3">
    <!-- Loading skeleton -->
    <div *ngIf="isLoading()" class="contact-card bg-white rounded-2xl p-5 space-y-3">
      <div class="h-4 w-1/2 rounded skeleton"></div>
      <div class="h-3 w-full rounded skeleton"></div>
      <div class="h-12 w-full rounded-xl skeleton"></div>
      <div class="h-12 w-full rounded-xl skeleton"></div>
    </div>

    <div *ngIf="error()" class="contact-card bg-white rounded-2xl p-6 text-center">
      <img src="/icons/info_red.svg" alt="" class="w-8 h-8 mx-auto mb-2" />
      <p class="text-sm font-bold text-rose-600 m-0">{{ error() }}</p>
      <button
        type="button"
        (click)="load()"
        class="mt-3 px-4 h-9 rounded-xl bg-(--main-color) text-slate-900 text-xs font-bold border-0 cursor-pointer"
      >
        ลองใหม่
      </button>
    </div>

    <ng-container *ngIf="contact() as c">
      <!-- Company -->
      <section class="contact-card bg-white rounded-2xl p-5">
        <p class="text-[11px] font-bold text-slate-400 m-0">บริษัท</p>
        <p class="text-base font-extrabold text-slate-800 leading-snug m-0 mt-0.5">{{ c.companyNameTh }}</p>
        <p *ngIf="c.noteTh" class="text-sm text-slate-500 leading-relaxed whitespace-pre-wrap m-0 mt-2">{{ c.noteTh }}</p>

        <!-- Phones -->
        <div *ngIf="c.phone || c.phoneSecondary" class="mt-4 space-y-2">
          <a
            *ngIf="c.phone"
            [href]="telHref(c.phone)"
            class="call-btn flex items-center gap-3 h-14 px-4 rounded-xl bg-(--main-color) no-underline text-slate-900"
          >
            <span class="w-9 h-9 rounded-full bg-(--header-background) flex items-center justify-center shrink-0">
              <svg viewBox="0 0 24 24" class="w-[18px] h-[18px]" fill="rgb(255,197,39)" aria-hidden="true">
                <path
                  d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2z"
                />
              </svg>
            </span>
            <span class="min-w-0 flex-1">
              <span class="block text-[11px] font-bold text-slate-900/60">โทรหาเรา</span>
              <span class="block text-sm font-extrabold tracking-wide">{{ c.phone }}</span>
            </span>
            <img src="/icons/chevron_right_black.svg" alt="" class="w-5 h-5 opacity-60" />
          </a>

          <a
            *ngIf="c.phoneSecondary"
            [href]="telHref(c.phoneSecondary)"
            class="call-btn flex items-center gap-3 h-14 px-4 rounded-xl bg-white border border-slate-200 no-underline text-slate-800"
          >
            <span class="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center shrink-0">
              <svg viewBox="0 0 24 24" class="w-[18px] h-[18px]" fill="#475569" aria-hidden="true">
                <path
                  d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2z"
                />
              </svg>
            </span>
            <span class="min-w-0 flex-1">
              <span class="block text-[11px] font-bold text-slate-400">เบอร์สำรอง</span>
              <span class="block text-sm font-extrabold tracking-wide">{{ c.phoneSecondary }}</span>
            </span>
            <img src="/icons/chevron_right_slate.svg" alt="" class="w-5 h-5 opacity-50" />
          </a>
        </div>
      </section>

      <!-- Address -->
      <section *ngIf="c.addressTh" class="contact-card bg-white rounded-2xl p-4 flex items-start gap-3">
        <div class="w-10 h-10 rounded-xl bg-amber-50 border border-amber-100 flex items-center justify-center shrink-0">
          <img src="/icons/place_slate.svg" alt="" class="w-5 h-5" />
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-[11px] font-bold text-slate-400 m-0">ที่อยู่</p>
          <p class="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed m-0 mt-0.5">{{ c.addressTh }}</p>
        </div>
        <button
          type="button"
          (click)="copyAddress(c.addressTh)"
          class="w-9 h-9 rounded-full bg-slate-50 border border-slate-100 flex items-center justify-center shrink-0 cursor-pointer p-0"
          [attr.aria-label]="copied() ? 'คัดลอกแล้ว' : 'คัดลอกที่อยู่'"
        >
          <img [src]="copied() ? '/icons/check_emerald.svg' : '/icons/content_copy_slate.svg'" alt="" class="w-4 h-4" />
        </button>
      </section>

      <!-- Email -->
      <a
        *ngIf="c.email"
        [href]="mailHref(c.email)"
        class="contact-card bg-white rounded-2xl p-4 flex items-center gap-3 no-underline text-inherit"
      >
        <div class="w-10 h-10 rounded-xl bg-amber-50 border border-amber-100 flex items-center justify-center shrink-0">
          <img src="/icons/mail_slate.svg" alt="" class="w-5 h-5" />
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-[11px] font-bold text-slate-400 m-0">อีเมล</p>
          <p class="text-sm font-extrabold text-slate-800 break-all m-0 mt-0.5">{{ c.email }}</p>
        </div>
        <img src="/icons/chevron_right_slate.svg" alt="" class="w-5 h-5 opacity-50" />
      </a>

      <p *ngIf="copied()" class="text-center text-xs font-bold text-emerald-600 m-0">คัดลอกที่อยู่แล้ว</p>
    </ng-container>
  </div>
</div>
